module.exports = __webpack_public_path__ + "img/tournament_startgame.3e2c22bb.png";